import {
    TemplateCta,
    TemplateCtaProps
} from "@/libraries/design/components/template-cta/src/template-cta";

const UniformTemplateCta = (props: TemplateCtaProps) => {
    return <TemplateCta {...props} />;
};

export default UniformTemplateCta;
